import "../../styles/job_registration.css";
import CCLogoIcon from "../../assets/Care_Concierge_Logo.png";


const JobHeader = () => {
    return (
        <div>
            <div className="j-col-container">
                <div className="j-col header-content-container j-responsive">
                    <img className="j-logo" src= { CCLogoIcon } alt="Care Concierge"/>
                </div>
            </div>
        </div>
        
    )
}

export default JobHeader;
